import { ReactNode } from 'react'
import {
  SxProps,
  TypographyProps,
  Typography,
  IconButton,
  styled,
} from '@mui/material'
import { TypographyCustomVariant } from '$setup/material-theme'

const Root = styled('div')`
  display: flex;
  flex-direction: column;

  background-color: #fff;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 13px;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.05);
  text-align: right;
`

const Header = styled('div')`
  display: flex;
  align-items: center;
  margin: 12px 16px 4px;
`

interface Props {
  headerText?: string
  headerIcon?: JSX.Element
  headerEndIcon?: JSX.Element
  children: ReactNode
  headerVariant?: TypographyCustomVariant
  headerSx?: SxProps
  headerColor?: TypographyProps['color']
  onEndIconClick?: () => unknown
  sx?: SxProps
  className?: string
}

export function SettingsSection({
  headerText = '',
  headerIcon,
  headerEndIcon,
  onEndIconClick,
  children,
  headerVariant = 'subtitle3',
  headerColor = 'secondary700',
  sx,
  headerSx,
  className,
}: Props) {
  return (
    <Root sx={sx} className={className}>
      <>
        {headerText && (
          <Header sx={headerSx}>
            {headerIcon && (
              <div style={{ width: '16px', height: '16px' }}>{headerIcon}</div>
            )}

            <Typography
              color={headerColor ? headerColor : 'primary'}
              variant={headerVariant ? headerVariant : 'subtitle3'}
              sx={{ marginRight: headerIcon ? '5px' : 0, marginLeft: 'auto' }}
            >
              {headerText}
            </Typography>

            {headerEndIcon && (
              <IconButton onClick={onEndIconClick} size="small">
                {headerEndIcon}
              </IconButton>
            )}
          </Header>
        )}

        {children}
      </>
    </Root>
  )
}
